<template>
  <div class="range">
    <div class="range__track">
      <div class="range__thumb"></div>
      <div
        class="range__value"
        :style="{ background: color, width: thumbWidth }"
      ></div>
      <div
        class="range__marker"
        :style="{ background: color, left: thumbWidth }"
      >
        {{ currentValue.title }} {{units}}
      </div>
      <div
        class="range__circle"
        :style="{ background: color, left: thumbWidth }"
        @mousedown.left="startMoving"
      ></div>
      <div class="range__circles">
        <div v-for="(item, i) in data" :key="i" @click="() => handleCircleClick(item)"></div>
      </div>
    </div>
    <div class="range__values">
      <span v-for="(item, i) in data" :key="i">{{item.title}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomRange",

  props: {
    min: {
      type: Object,
    },
    max: {
      type: Object,
    },
    step: {
      type: Number,
      default: 1,
    },
    value: {
      type: Object,
    },
    color: {
      type: String,
      required: false,
      default: "rgba(0, 149, 182, 1)",
    },
    units: {
      type: String,
      required: false
    },
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentValue: this.value,
    };
  },

  emits: ["change"],

  computed: {
    thumbWidth() {
      return (this.currentValue.value * 100) / (this.max.value - this.min.value) + "%";
    },
  },

  created() {
    if (!this.min && this.data) {
      this.min = this.data[0];
    }
    if (!this.max && this.data) {
      this.max = this.data[this.data.length - 1];
    }
    if (!this.value && this.data) {
      this.currentValue = this.data[0];
    }
  },

  methods: {
    handleCircleClick(item) {
      this.currentValue = item;
      this.$emit("change", item);
    },
    startMoving(e) {
      const track = e.target.closest(".range__track");
      track.addEventListener("mousemove", this.mouseMove);
      track.addEventListener("mouseup", this.mouseUp);
    },
    mouseMove(e) {
      const track = e.target.closest(".range__track");
      this.calcNewValue(track, e.clientX)
    },
    calcNewValue(track, clientX) {
      const trackWidth = track.clientWidth,
        trackLeft = track.getBoundingClientRect().x;

      const k = 10;
      let newValue = Math.round(((clientX - trackLeft) * (this.data.length * k)) / trackWidth);
      console.log(newValue)

      if (newValue > this.currentValue.value * k) {
        newValue = Math.floor(newValue / k);
      } else {
        newValue = Math.ceil(newValue / k);
      }

      if (Math.abs(this.currentValue.value - newValue) >= this.step / 2) {
        if (this.currentValue.value - newValue >= 0) {
          newValue = this.currentValue.value - this.step;
        } else {
          newValue = this.currentValue.value + this.step;
        }

        newValue = newValue >= this.min.value ? newValue : this.min.value;
        newValue = newValue <= this.max.value ? newValue : this.max.value;
        const item = this.findItemByValue(newValue);
        this.currentValue = item;
        this.$emit("change", item);
      } else if (newValue === this.min.value || newValue === this.max.value) {
        const item = this.findItemByValue(newValue);
        this.currentValue = item;
        this.$emit("change", item);
      }
    },
    findItemByValue(value) {
      return this.data.find(el => el.value === value);
    },
    mouseUp(e) {
      const track = e.target.closest(".range__track");
      track.removeEventListener("mousemove", this.mouseMove);
      track.removeEventListener("mouseup", this.mouseUp);
    },
  },
};
</script>

<style lang="sass" scoped>
.range
  position: relative
  width: 100%

.range__track, .range__thumb
  position: relative
  box-sizing: border-box
  height: 4px
  border-radius: 10px

.range__value
  box-sizing: border-box
  height: 4px
  border-radius: 10px
  position: absolute
  top: 50%

.range__circle
  display: flex
  align-items: center
  justify-content: center
  position: absolute
  font-size: 12px
  height: 20px
  width: 20px
  top: 50%
  transform: translate(-50%, -50%)
  border-radius: 50%
  background: #333
  color: #fff
  cursor: pointer
  user-select: none
  z-index: 3

.range__marker
  display: flex
  align-items: center
  justify-content: center
  position: absolute
  font-weight: 500
  font-size: 1rem
  line-height: 0.95rem
  top: -49px
  transform: translateX(-50%)
  border-radius: 4px
  padding: 11px 3px
  color: #ffffff
  cursor: pointer
  user-select: none
  white-space: nowrap

  &::before
    content: "▼"
    position: absolute
    top: calc(100% - 4px)
    color: rgba(0, 149, 182, 1)

.range__track
  width: 100%
  padding: 13px 0

.range__thumb
  width: 100%
  background: #eee

.range__values
  display: flex
  justify-content: space-between
  gap: 10px
  width: 100%
  font-weight: 500
  font-size: 0.75rem
  line-height: 0.7rem
  padding-top: 7px

.range__circles
  display: flex
  position: absolute
  width: 100%
  justify-content: space-between
  align-items: center
  top: 50%
  transform: translateY(calc(-50% + 2px))
  z-index: 2

  div
    border: 3px solid rgba(0, 149, 182, 1)
    width: 10px
    height: 10px
    border-radius: 50%
    z-index: 2
    background: #ffffff
    cursor: pointer
</style>
